import React, { useEffect, useRef } from "react"
import { AvatarIcon } from "../../../components/Avatar"
import { Button, ButtonLoader } from "../../../components/Button"
import { TextArea, TextAreaAutoSize } from "../../../components/Form"
import "./styles.scss"
import moment from "moment"
import { formatTimestampToDate } from "../../../container/PlanningContainer"
import { Spinner } from "../../../components/Loading"

const hexToRgb = (hex) => {
  const normalizedHex = hex?.replace("#", "")
  const isShortHex = normalizedHex?.length === 3

  const parseComponent = (component) => parseInt(component?.repeat(isShortHex ? 2 : 1), 16)

  if (isShortHex) {
    return normalizedHex?.split("")?.map(parseComponent)
  } else {
    return normalizedHex?.match(/.{1,2}/g)?.map(parseComponent)
  }
}

const isHexTooLight = (hexColor) => {
  const [r, g, b] = hexToRgb(hexColor)
  const luminance = (r * 299 + g * 587 + b * 114) / 1000
  return luminance > 155
}

const CommentSection = ({ comment, key }) => {
  const checkIsPipe = comment?.comment_text.includes("|")
  const strObj = checkIsPipe
    ? {
        username: comment?.comment_text.split("|")[0],
        message: comment?.comment_text.split("|")[1],
      }
    : { username: comment?.user?.username, message: comment?.comment_text }

  return (
    <div className={`planning-section-comments-area comment last-comments`} key={key}>
      <div className="text-box-comment-info">
        <span>{strObj?.username}</span> -{" "}
        {moment(formatTimestampToDate(comment?.date)).format("DD/MM/YYYY")}
      </div>
      <div className="comment-creator">
        <div className="comment-creator-avatar">
          <AvatarIcon
            color={
              comment?.user?.color === "" ||
              (comment?.user?.color !== "" && isHexTooLight(comment?.user?.color))
                ? "000"
                : "FFFF"
            }
            backgroundColor={comment?.user?.color?.split("#")[1]}
            size="30"
            name={strObj?.username}
          />
        </div>

        <div className="text-box">
          <div className="text-box-only-visible">
            <span>{strObj?.message}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

const CommentsComponent = ({
  loggedUser,
  clickedCard,
  onChange,
  values,
  handleCreateComment,
  openEditOptions,
  closeTextArea,
  showCommentAdd,
  loadingComment,
  loadingComments,
}) => {
  const ref = useRef(null)

  useEffect(() => {
    if (showCommentAdd === clickedCard?.creator?.id) {
      ref.current?.scrollIntoView({ behavior: "smooth" })
    }
  }, [showCommentAdd, clickedCard])


  return (
    <div className="planning-section-comments" ref={ref}>
      <div className="comments-title">
        <h4>{`Comentários ${clickedCard?.comments?.length > 0 ? `(${clickedCard?.comments?.length})` : ""}`}</h4>
        {loadingComments && <><Spinner size="small" color="primary"/></>}
      </div>
      <div className="planning-section-comments-area comment creator">
        <div className="text-box-comment-info creator">{loggedUser?.name}</div>
        <div className="comment-creator">
          <div className="comment-creator-avatar">
            <AvatarIcon color={"000"} size="30" name={loggedUser?.name} />
          </div>
          {showCommentAdd !== clickedCard?.creator?.id && (
            <div className="text-box">
              <div
                className="text-box-only-visible add-value"
                onClick={() => openEditOptions(clickedCard?.creator?.id)}>
                <span>Adicione um comentário...</span>
              </div>
            </div>
          )}
          {showCommentAdd === clickedCard?.creator?.id && (
            <TextAreaAutoSize
              isAutoScroll={true}
              isAutofocus={true}
              resize="none"
              placeholder="Adicione um comentário..."
              value={values?.commentCreator}
              onChange={(e) => onChange("commentCreator", e?.target?.value)}
            />
          )}
        </div>
        {showCommentAdd === clickedCard?.creator?.id && (
          <div className="planning-section-comments-area-button">
            <Button
              isDisabled={loadingComment}
              color="danger"
              handleClick={() => closeTextArea()}
              label="Cancelar"
            />
            <ButtonLoader
              loading={loadingComment}
              messageProcess="Salvando"
              color="orange"
              handleClick={() => handleCreateComment()}
              label="Salvar"
            />
          </div>
        )}
      </div>

      {clickedCard &&
        clickedCard?.comments?.length > 0 &&
        clickedCard?.comments.map((comment) => (
          <CommentSection key={comment?.id} comment={comment} />
        ))}
    </div>
  )
}

export default CommentsComponent
